import {EventEmitter, Injectable} from '@angular/core';
import { CatalogItem, CataloguesHttpService } from 'banesco-catalogues-api';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

export enum CATALOGUE_IDS {
  BANESCO_PRODUCTS = '28',
  ID_TYPES = '6',
  BANESCO_CURRENCY = '7',
  BENEFICIARY_PRODUCT_TYPES = '10',
  BENEFICIARY_TYPES = '12',
  BANKS = 'BankBL',
  LOCAL_SENDING_CHANNEL = 'TRFLOC',
  REGIONAL_SENDING_CHANNEL = 'TRFRGN',
  INTERNATIONAL_SENDING_CHANNEL = 'TRFINT',
  LOCAL_TRANSFER_CURRENCIES = 'TRASFCRY',
  INTERNATIONAL_TRANSFER_CURRENCIES = 'TRINTCRY',
  BENEFICIARY_GROUP = 'TRFRTIL',
  CATALOGUE_SERVICES_PAY = 'PGFI',
}


@Injectable()
export class  BnCataloguesService {
  banks?: CatalogItem[];
  idTypes?: CatalogItem[];
  currencies?: CatalogItem[];
  productTypes?: CatalogItem[];
  beneficiaryTypes?: CatalogItem[];
  beneficiaryProductTypes?: CatalogItem[];
  localSendingChannels?: CatalogItem[];
  regionalSendingChannels?: CatalogItem[];
  internationalSendingChannels?: CatalogItem[];
  localTransferCurrencies?: CatalogItem[];
  catalogueServices?: CatalogItem[];
  catalogueGroupPay?: CatalogItem[];
  selectedSendingChanel$: EventEmitter<any> = new EventEmitter<any>()

  constructor(private catalogsHTTPService: CataloguesHttpService) {}

  getBanks(): Observable<CatalogItem[]> {
    return this.banks?.length
      ? of(this.banks)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.BANKS }).pipe(
          map((values: CatalogItem[]) => {
            return [...values];
          }),
          tap((values) => {
            this.banks = [...values];
          }),
        );
  }

  getCurrencies(): Observable<CatalogItem[]> {
    return this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.BANESCO_CURRENCY }).pipe(
          map((values: CatalogItem[]) => {
            return [...values];
          }),
          tap((values) => {
            this.currencies = [...values];
          }),
        );
  }

  getCurrenciesInter(): Observable<CatalogItem[]> {
    return this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.INTERNATIONAL_TRANSFER_CURRENCIES }).pipe(
          map((values: CatalogItem[]) => {
            return [...values];
          }),
          tap((values) => {
            this.currencies = [...values];
          }),
        );
  }

  getCurrenciesInternational(): Observable<CatalogItem[]> {
    return this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.INTERNATIONAL_TRANSFER_CURRENCIES }).pipe(
          map((values: CatalogItem[]) => {
            return [...values];
          }),
          tap((values) => {
            this.currencies = [...values];
          }),
        );
  }

  getLocalTransferCurrencies(): Observable<CatalogItem[]> {
    return this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.LOCAL_TRANSFER_CURRENCIES }).pipe(
          map((values: CatalogItem[]) => {
            return [...values];
          }),
          tap((values) => {
            this.currencies = [...values];
          }),
        );
  }

  getProductTypes(): Observable<CatalogItem[]> {
    return this.productTypes?.length
      ? of(this.productTypes)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.BANESCO_PRODUCTS }).pipe(
          map((values: CatalogItem[]) => {
            return [...values];
          }),
          tap((values) => {
            this.productTypes = [...values];
          }),
        );
  }

  getBeneficiaryTypes(): Observable<CatalogItem[]> {
    return this.beneficiaryTypes?.length
      ? of(this.beneficiaryTypes)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.BENEFICIARY_TYPES }).pipe(
          map((values: CatalogItem[]) => {
            return [...values];
          }),
          tap((values) => {
            this.beneficiaryTypes = [...values];
          }),
        );
  }

  getBeneficiaryTypesGroup(): Observable<CatalogItem[]> {
    return this.beneficiaryTypes?.length
      ? of(this.beneficiaryTypes)
      : this.catalogsHTTPService.getCatalogByGroupId({ groupId: CATALOGUE_IDS.BENEFICIARY_GROUP }).pipe(
        map((values: CatalogItem[]) => {
          return [...values];
        }),
        tap((values) => {
          this.beneficiaryTypes = [...values];
        }),
      );
  }

  getCatalogueServicesCategory(): Observable<CatalogItem[]> {
    return this.catalogueServices?.length
      ? of(this.catalogueServices)
      : this.catalogsHTTPService.getCatalogByGroupId({ groupId: CATALOGUE_IDS.CATALOGUE_SERVICES_PAY }).pipe(
        map((values: CatalogItem[]) => {
          return [...values];
        }),
        tap((values) => {
          this.catalogueServices = [...values];
        }),
      );
  }

  getCatalogGroup(id: string): Observable<CatalogItem[]> {
    return this.catalogsHTTPService.getCatalogByGroupId({ groupId: `${id}` }).pipe(
      map((values: CatalogItem[]) => {
        return [...values];
      }),
      tap((values) => {
        this.catalogueGroupPay = [...values];
      }),
    );
  }



  getBeneficiaryProductTypes(): Observable<CatalogItem[]> {
    return this.beneficiaryProductTypes?.length
      ? of(this.beneficiaryProductTypes)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.BENEFICIARY_PRODUCT_TYPES }).pipe(
          map((values: CatalogItem[]) => {
            return [...values];
          }),
          tap((values) => {
            this.beneficiaryProductTypes = [...values];
          }),
        );
  }

  getIdTypes(): Observable<CatalogItem[]> {
    return this.idTypes?.length
      ? of(this.idTypes)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.ID_TYPES }).pipe(
          map((values: CatalogItem[]) => {
            return [...values];
          }),
          tap((values) => {
            this.idTypes = [...values];
          }),
        );
  }

  getLocalSendingChannels(): Observable<CatalogItem[]> {
    return this.localSendingChannels?.length
      ? of(this.localSendingChannels)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.LOCAL_SENDING_CHANNEL }).pipe(
          map((values: CatalogItem[]) => {
            return [...values];
          }),
          tap((values) => {
            this.localSendingChannels = [...values];
          }),
        );
  }

  getRegionalSendingChannels(): Observable<CatalogItem[]> {
    return this.regionalSendingChannels?.length
      ? of(this.regionalSendingChannels)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.REGIONAL_SENDING_CHANNEL }).pipe(
          map((values: CatalogItem[]) => {
            return [...values];
          }),
          tap((values) => {
            this.regionalSendingChannels = [...values];
          }),
        );
  }

  getInternationalSendingChannels(): Observable<CatalogItem[]> {
    return this.internationalSendingChannels?.length
      ? of(this.internationalSendingChannels)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.INTERNATIONAL_SENDING_CHANNEL }).pipe(
          map((values: CatalogItem[]) => {
            return [...values];
          }),
          tap((values) => {
            this.internationalSendingChannels = [...values];
          }),
        );
  }

  getCatalogByID(id: string): Observable<any> {
    return this.catalogsHTTPService.getCatalogTDCById(id);
  }
}